/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetSortedLocationsByPlanDateQueryResult } from '../../models/get-sorted-locations-by-plan-date-query-result';

export interface ApiLocationGetSortedLocationsByPlanDateGet$Params {
  DistrictId?: string;
}

export function apiLocationGetSortedLocationsByPlanDateGet(http: HttpClient, rootUrl: string, params?: ApiLocationGetSortedLocationsByPlanDateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSortedLocationsByPlanDateQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiLocationGetSortedLocationsByPlanDateGet.PATH, 'get');
  if (params) {
    rb.query('DistrictId', params.DistrictId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetSortedLocationsByPlanDateQueryResult>;
    })
  );
}

apiLocationGetSortedLocationsByPlanDateGet.PATH = '/api/Location/GetSortedLocationsByPlanDate';
